module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-calabria-outdoor.svg?308219269e012f62d492fc0494f14ab8";